import HeroSection from '@/components/HeroSection';
import PillarsSection from '@/components/PillarsSection';
import PrologueSection from '@/components/PrologueSection';
import MiniCtaSection from '@/components/MiniCtaSection';

export default function Home() {
  return (
    <main className="bg-[#06121F] text-white">
      <HeroSection />
      <PillarsSection />
      <PrologueSection />
      <MiniCtaSection />
    </main>
  );
}
